import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import CryptoJS from 'crypto-js';
import { NgxSpinnerService } from 'ngx-spinner';
import { DxauthService } from 'src/app/dxauth.service';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { Auth0Service } from 'src/app/shared/services/auth0.service';
import { environment } from 'src/environments/environment';

const passwordKey = '14accb2b-30de-4de8-8516-d343c214d530';
const localStorageKeys = {
  iv: 'sgzp_iv',
  salt: 'sgzp_salt',
  main: 'sgzp_email_password',
};

@Component({
  selector: 'app-modal-component',
  template: `
    <div style="text-align: right; margin-right: -24px; margin-top: -24px;">
      <button
        mat-fab
        color="primary"
        aria-label="Example icon button with a delete icon"
        (click)="closeDialog()"
      >
        <img src="/assets/sgzp-app2/images/close.svg" alt="" />
      </button>
    </div>
    <h1 class="mb-10 h3">
      このメールアドレスはコラボポータルに連携することが可能です。
    </h1>
    <p class="v-text">
      コラボポータルにログインすることで、ご本人確認などの登録手続きを省略することができます。
    </p>
    <div class="text-center">
      <button
        type="button"
        class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default full-width"
        medium=""
        style="background-color: #0075C2; color: #fff;"
        [mat-dialog-close]="true"
      >
        <span class="v-btn__content"> コラボポータルへログイン </span>
      </button>
    </div>
  `,
  styleUrls: ['./sgzp-app2.component.css', '../style/global.css'],
})
export class ModalComponent {
  constructor(private dialog: MatDialog) {}

  closeDialog(): void {
    this.dialog.closeAll();
  }
}
@Component({
  selector: 'app-sgzp-app2',
  templateUrl: './sgzp-app2.component.html',
  styleUrls: ['./sgzp-app2.component.css', '../style/global.css'],
})
export class SgzpApp2Component extends BaseLoginComponent implements OnInit {
  private message: undefined | { date: string; title: string; message: string };
  constructor(
    activateRoute: ActivatedRoute,
    auth0: Auth0Service,
    dxauth: DxauthService,
    spinner: NgxSpinnerService,
    public router: Router,
    public title: Title,
    private http: HttpClient,
    private datePipe: DatePipe,
    private dialog: MatDialog
  ) {
    super(activateRoute, auth0, dxauth, spinner, router, title);

    if (this.page === 'login') {
      this.onLoginPage();
    }
  }

  async login() {
    try {
      if (!this.isLoginInfoInput()) return;
      this.spinner.show();
      // 事前のパスワードチェック. 存在しない場合はcatchに飛ぶ
      await this.isValidEmailAndPassword();

      // パスワードチェックが通ったらフラグ関連処理実施
      const flags = await this.auth.getFlags({
        clientId: this.clientId,
        email: this.email,
        redirectUri: this.redirectUri,
      });
      // cp_productsがtrueの場合はログインさせる
      if (flags.cp_products) {
        return super.login();
      }
      // // 他サービスのフラグも立っていない場合は弾く(通常のログイン処理を実施してうちきる)
      // if (!flags.doctors_products) {
      //   // ログイン処理をさせるルートに入れる
      //   return super.login();
      // }
      this.spinner.hide();

      // ダイアログ表示
      const dialogRef = this.dialog.open(ModalComponent, {
        width: '320px',
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe(async (result) => {
        // コラボポータルへログインが押された場合
        if (result) {
          // 環境変数設定からコラボポータルのclient_idを取得
          const cportalClientId = this.app?.sgzpApp2?.cportalClientId;
          if (!cportalClientId) {
            return;
          }
          // そこからコラボポータルのURLを取得して別タブで開く
          const cportalUrl = environment.apps[cportalClientId].appUrl;
          window.open(cportalUrl, '_blank');
        }
      });
    } catch (error) {
      console.log(error);
      this.spinner.hide();
    }
  }

  private onLoginPage() {
    const nowDate = this.datePipe.transform(new Date(), 'yyyyMMdd');
    this.http
      .get(`${this.app?.sgzpApp2?.loginMessageUrl}?now_date=${nowDate}`)
      .toPromise()
      .then((e) => {
        const response = e as {
          nb_err_cod: '200' | '400' | '500';
          err_msg: null | string;
          err_level: 'S';
          msg_inf: [
            {
              msg_niy: string; //'<p><h1><font color=#336666>[STG環境]</font></h1></p><p><font color="#3598db">Suzuken presents.</font>『発注提案サービス』</p>';
            }
          ];
        };
        if (response.nb_err_cod !== '200') {
          throw new Error(response.err_msg || '');
        }
        if (response.msg_inf.length && response.msg_inf.length > 0) {
          this.message = {
            date: '2023.8.14',
            title: 'ここにタイトルが入ります',
            message: response.msg_inf[0].msg_niy,
          };
        }
      })
      .catch((error) => {
        // this.message = {
        //   date: '2023.8.14',
        //   title: 'ここにタイトルが入ります',
        //   message:
        //     'ここにメッセージが入ります。ここにメッセージが入ります。ここにメッセージが入ります。ここにメッセージが入ります。ここにメッセージが入ります。',
        // };
      });
  }

  // 登録サポートツール用か否か
  get isDxsales() {
    const app = environment.apps[this.clientId];
    return app.connection === 'CBPT-DxSales';
  }
  // 登録サポートツール用か否か
  get isKanri() {
    const app = environment.apps[this.clientId];
    return app.connection === 'CBPT-Kanri';
  }
  get registerUrl() {
    const app = environment.apps[this.clientId];
    return app?.sgzpApp2?.registerUrl || 'https://google.com';
  }
  get isFromNativeApp() {
    const app = environment.apps[this.clientId];
    return app?.sgzpApp2?.isFromNativeApp || false;
  }
  get loginTitleText() {
    const app = environment.apps[this.clientId];
    return app?.sgzpApp2?.isFromNativeApp
      ? '発注提案アプリ'
      : '発注提案サービス';
  }

  saveEmailAddress() {
    // メール・パスワード保存処理. 改行区切りでメール・パスワードを一つの文字列にして、暗号化して保存する
    localStorage.setItem(
      localStorageKeys.main,
      this.getEncryptData([this.email, this.password].join('\n'), passwordKey)
    );
  }

  setSalt(salt: string) {
    localStorage.setItem(localStorageKeys.salt, salt);
  }
  getSalt() {
    return localStorage.getItem(localStorageKeys.salt);
  }
  getIv() {
    return localStorage.getItem(localStorageKeys.iv);
  }
  setIv(ivStr: string) {
    localStorage.setItem(localStorageKeys.iv, ivStr);
  }

  loadEmailFromStorage() {
    // 複合前の文字列を取得
    const saved = localStorage.getItem(localStorageKeys.main);

    // 保存されていれば、複合する
    if (saved) {
      // 複合したデータ
      const decryptedEmail = this.getDecryptData(saved, passwordKey) as string;
      // 改行区切りになっているので取り出す
      const decryptedSplitedString = decryptedEmail.split('\n');
      this.email = decryptedSplitedString[0];
      this.password = decryptedSplitedString[1];
      this.isSaveEmail = true;

      return true;
    }
    return false;
  }

  clearEmailAddress() {
    localStorage.removeItem(localStorageKeys.main);
    localStorage.removeItem(localStorageKeys.iv);
    localStorage.removeItem(localStorageKeys.salt);
  }

  /**
   *  暗号化
   *  @param data 暗号化する値
   *  @param pass パス
   *  @returns 暗号化された値
   */
  getEncryptData(data: string, pass: string) {
    // ソルト
    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    // 初期ベクトル
    var ivStr = CryptoJS.lib.WordArray.random(128 / 8).toString();
    var iv = CryptoJS.enc.Hex.parse(ivStr);
    // AESキーの生成
    const key = CryptoJS.PBKDF2(pass, salt.toString(), {
      keySize: 128 / 32,
      iterations: 50000,
      hasher: CryptoJS.algo.SHA256,
    });
    // AESキーで暗号化
    const encryptData = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
    });
    this.setSalt(salt);
    this.setIv(ivStr);
    return encryptData.toString();
  }
  /**
   *  複合化
   *  @param data 暗号化された値
   *  @param pass パス
   *  @returns 複合された値
   */
  getDecryptData(data: string, pass: string) {
    // AESキーの生成
    const key = CryptoJS.PBKDF2(pass, this.getSalt(), {
      keySize: 128 / 32,
      iterations: 50000,
      hasher: CryptoJS.algo.SHA256,
    });

    // AESキーで復号
    const decryptData = CryptoJS.AES.decrypt(data, key, {
      iv: CryptoJS.enc.Hex.parse(this.getIv()),
    });
    return decryptData.toString(CryptoJS.enc.Utf8);
  }
}
